import axios from 'axios';

// Public routes: no Bearer token (guest / MP callbacks). Match is substring on URL.
const publicRoutes = [
  '/signin',
  '/signup',
  '/api/auth/login',
  '/api/auth/register',
  '/api/settings/public',
  '/api/faqs/published',
  '/api/faqs/categories',
  '/api/faqs/search',
  '/api/faqs/tags',
  '/api/faqs/category/',
  '/api/reservas/detail',
  '/api/reservas/submit-proof',
  '/api/compradores',
  '/api/mercadopago/preference',
  '/api/mercadopago/transaction',
  '/api/mercadopago/verify-and-confirm',
  '/api/mercadopago/config',
  '/api/newsletter/subscribe',
  '/api/cuentas/public',
];

function isPublicRequest(config) {
  const url = config.url || '';
  const method = (config.method || 'get').toLowerCase();

  if (url.includes('/api/reservas/')) {
    if (method === 'post' && /\/api\/reservas\/?$/.test(url)) return true;
    if (method === 'get' && url.includes('/api/reservas/detail/')) return true;
    if (method === 'put' && url.includes('/api/reservas/submit-proof/')) return true;
  }

  // Same path as admin PUT; only GET is public (buyer checkout reads flag)
  if (url.includes('/api/mercadopago/webhookConfig') && method === 'get') {
    return true;
  }

  return publicRoutes.some(route => url.includes(route));
}

// Create axios instance
const axiosInstance = axios.create();

// Flag to prevent multiple redirects
let isRedirecting = false;

// Add request interceptor
axiosInstance.interceptors.request.use(
  config => {
    // Reset redirect flag on new requests
    isRedirecting = false;

    const isPublicRoute = isPublicRequest(config);

    // Get token from localStorage
    const userInfo = localStorage.getItem('userInfo')
      ? JSON.parse(localStorage.getItem('userInfo'))
      : null;

    // If token exists and route is not public, add to headers
    if (userInfo?.token && !isPublicRoute) {
      config.headers.Authorization = `Bearer ${userInfo.token}`;
    }

    return config;
  },
  error => {
    return Promise.reject(error);
  }
);

// Add response interceptor
axiosInstance.interceptors.response.use(
  response => response,
  error => {
    // Handle 401 Unauthorized responses
    if (error.response && error.response.status === 401 && !isRedirecting) {
      const isPublicRoute = isPublicRequest(error.config || {});
      if (!window.location.pathname.includes('/signin') && !isPublicRoute) {
        isRedirecting = true;
        localStorage.removeItem('userInfo');
        window.location.href = '/signin';
      }
    }
    return Promise.reject(error);
  }
);

export default axiosInstance;
